import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import banksData from '../helper/banks.json';

export const useAccountStore = defineStore('account', () => {
  const stripeAccountStatus = ref(window.initialState.stripeAccountStatus);
  const hasBillingInformations = ref(!!window.initialState.relatedOrganization?.client_invoice_data?.legal_name);
  const payOrganizationSeller = ref(window.initialState.payOrganizationSeller);
  const payOrganizationBuyer = ref(window.initialState.payOrganizationBuyer);
  const account = ref(window.initialState.account);
  const stripePortalLink = ref(window.initialState.stripePortalLink);
  const paymentMethod = ref(window.initialState.paymentMethodDetails);

  const banks = ref(banksData);

  const getBankName = (code) => banks.value[code] ?? null;

  const setStripeAccountStatus = (value) => {
    stripeAccountStatus.value = value;
  };
  const setHasBillingInformations = (value) => {
    hasBillingInformations.value = value;
  };
  const setPayOrganizationSeller = (value) => {
    payOrganizationSeller.value = value;
  };
  const setPayOrganizationBuyer = (value) => {
    payOrganizationBuyer.value = value;
  };

  const setPaymentMethod = (value) => {
    paymentMethod.value = value;
  };

  const setPortalLink = (value) => {
    stripePortalLink.value = value;
  };

  const statusFormatted = computed(() => stripeAccountStatus.value?.toString().toLowerCase());

  return {
    stripeAccountStatus,
    payOrganizationSeller,
    payOrganizationBuyer,
    paymentMethod,
    stripePortalLink,
    hasBillingInformations,
    setHasBillingInformations,
    setStripeAccountStatus,
    setPayOrganizationSeller,
    setPayOrganizationBuyer,
    setPaymentMethod,
    setPortalLink,
    statusFormatted,
    account,
    getBankName,
  };
});
